<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { getCurrentVariant } from "../../../functions/helper/product"

    export let variants: BKDFProductVariant[],
        backgroundColor: string = "black",
        selectedColor: BKDFProductSelectedOption,
        selectedSize: BKDFProductSelectedOption,
        product: BKDFProduct

    const dispatcher = createEventDispatcher()
</script>

<ul class="productVariants {backgroundColor}">
    {#each variants.map((v) => v.selectedOptions.find((o) => o.name === "Farbe").value) as value, i}
        <li>
            <button
                class:active="{value === selectedColor?.value}"
                class:available="{selectedSize
                    ? getCurrentVariant(product, [{ name: 'Farbe', value }, selectedSize])?.availableForSale
                        ? true
                        : false
                    : true}"
                on:click="{() => {
                    dispatcher('colorChange', {
                        color: value,
                    })
                }}"
            >
                <img
                    src="{variants[i].defaultImage?.url}"
                    alt="{variants[i].defaultImage?.altText}"
                />
            </button>
        </li>
    {/each}
</ul>

<style lang="less">
    .productVariants {
        width: 100%;
        height: 3.4rem;
        padding: 2px 0px;
        &.black {
            background-color: black;
        }
        &.white {
            background-attachment: white;
        }
        display: flex;
        button {
            cursor: pointer;
            border: 2px solid black;
            border-radius: 2px;
            width: 3.4rem;
            height: 100%;
            border: 2px solid black;
            pointer-events: none;
            opacity: 0.5;
            &.available {
                pointer-events: all;
                opacity: 1;
            }
            &.active {
                border: 2px solid var(--primary-200);
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        &.white {
            button {
                border: 2px solid white;
                &.active {
                    border: 2px solid var(--primary-200);
                }
            }
        }
    }
</style>
